import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import StaffService from '../services/staffService';
import { Staff } from '../types';

const StaffDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [staff, setStaff] = useState<Staff | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchStaff();
  }, [id]);

  const fetchStaff = async () => {
    try {
      setLoading(true);
      const response = await StaffService.getById(Number(id));
      setStaff(response.data);
      setError(null);
    } catch (err) {
      setError('Không thể tải thông tin nhân viên. Vui lòng thử lại sau.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (window.confirm('Bạn có chắc chắn muốn xóa nhân viên này?')) {
      try {
        await StaffService.remove(Number(id));
        navigate('/admin/staff');
      } catch (err) {
        setError('Không thể xóa nhân viên. Vui lòng thử lại sau.');
        console.error(err);
      }
    }
  };

  return (
    <div className="content">
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="card-title">Thông tin chi tiết nhân viên</h4>
                <div>
                  <Link to="/admin/staff" className="btn btn-secondary me-2">
                    <i className="nc-icon nc-minimal-left"></i> Quay lại
                  </Link>
                  <Link to={`/admin/staff/edit/${id}`} className="btn btn-warning me-2">
                    <i className="nc-icon nc-ruler-pencil"></i> Sửa
                  </Link>
                  <button className="btn btn-danger" onClick={handleDelete}>
                    <i className="nc-icon nc-simple-remove"></i> Xóa
                  </button>
                </div>
              </div>
            </div>
            <div className="card-body">
              {error && <div className="alert alert-danger">{error}</div>}

              {loading ? (
                <div className="text-center">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Đang tải...</span>
                  </div>
                </div>
              ) : staff ? (
                <div className="row">
                  <div className="col-md-12">
                    <div className="staff-details">
                      <table className="table table-borderless">
                        <tbody>
                          <tr>
                            <th style={{ width: '200px' }}>ID:</th>
                            <td>{staff.id}</td>
                          </tr>
                          <tr>
                            <th>Tên đăng nhập:</th>
                            <td>{staff.username}</td>
                          </tr>
                          <tr>
                            <th>Họ và tên:</th>
                            <td>{staff.fullName || 'N/A'}</td>
                          </tr>
                          <tr>
                            <th>Vai trò:</th>
                            <td>
                              {staff.role === 'admin' ? 'Quản trị viên' : 
                              staff.role === 'staff' ? 'Nhân viên' : staff.role || 'N/A'}
                            </td>
                          </tr>
                          <tr>
                            <th>Ngày tạo:</th>
                            <td>
                              {staff.createdAt
                                ? new Date(staff.createdAt).toLocaleString()
                                : 'N/A'}
                            </td>
                          </tr>
                          <tr>
                            <th>Cập nhật lần cuối:</th>
                            <td>
                              {staff.updatedAt
                                ? new Date(staff.updatedAt).toLocaleString()
                                : 'N/A'}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="alert alert-warning">Không tìm thấy thông tin nhân viên.</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffDetail; 